import { useState } from "react";
import { toast } from "react-toastify";

/**
 * "Use my location" button — reads the device GPS via the browser Geolocation
 * API and reports { lat, lng } to the parent. No dependency required.
 *
 * Props:
 *   onLocate(lat, lng) : called with the captured coordinates (6-dp rounded).
 *
 * Note: browsers only allow geolocation over HTTPS or http://localhost.
 */
export const GpsButton = ({ onLocate }) => {
  const [busy, setBusy] = useState(false);

  const handleClick = () => {
    if (!("geolocation" in navigator)) {
      toast.error("GPS is not supported by this browser.", { autoClose: 5000 });
      return;
    }
    setBusy(true);
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        const lat = Number(pos.coords.latitude.toFixed(6));
        const lng = Number(pos.coords.longitude.toFixed(6));
        onLocate && onLocate(lat, lng);
        toast.success(`Location captured (${lat}, ${lng}).`, { autoClose: 4000 });
        setBusy(false);
      },
      (err) => {
        const msg =
          err.code === 1 ? "Location permission denied."
          : err.code === 2 ? "Location unavailable."
          : err.code === 3 ? "Location request timed out."
          : "Could not get your location.";
        toast.error(msg, { autoClose: 5000 });
        setBusy(false);
      },
      { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 }
    );
  };

  return (
    <button type="button" className="btn btn-soft-info w-100" onClick={handleClick} disabled={busy}>
      {busy ? (
        <><span className="spinner-border spinner-border-sm me-1"></span> Locating…</>
      ) : (
        <><i className="ri-map-pin-user-line me-1"></i> Use my GPS location</>
      )}
    </button>
  );
};

export default GpsButton;
